<template>
  
  <div class="header text-right">
    <MemberTopbar :user="currentMember"></MemberTopbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import MemberTopbar from '@/view/pages/members/loggedin/MemberTopbar.vue';

export default {
  name: 'MemberHeader',
  components: {
    MemberTopbar,
  },
  mounted() {
    
  },
  computed: {
    ...mapGetters([
      'currentMember'      
    ]),

  }
};
</script>

<style scoped>
.header {
  height: 52px;
}
</style>
